/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import gql from 'graphql-tag';
import { keys } from 'lodash';

import { Link } from '@coursera/cds-core';

import { prependUrlProtocolIfNone } from 'bundles/common/utils/urlUtils';
import withFragments from 'bundles/graphql/components/withFragments';
import { websitesInfo } from 'bundles/partners-graphql/constants';
import type { Websites } from 'bundles/partners-graphql/types/Websites';

const styles = {
  externalLinks: css`
    ul {
      width: 100%;
      list-style: none;
      vertical-align: top;
      line-height: 2;
      font-size: small;
    }

    li {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  `,
};

type Props = {
  websites: Websites | null;
};

const ExternalLinks = ({ websites }: Props) => {
  if (!websites) {
    return null;
  }
  const externalLinks = keys(websites) as (keyof Websites)[];

  return (
    <div css={styles.externalLinks} className="rc-ExternalLinks">
      <ul className="m-a-0 p-a-0">
        {externalLinks.map((link) => {
          const externalLinkInfo = websites[link] && websitesInfo[link];
          if (externalLinkInfo) {
            return (
              <li>
                <span className={externalLinkInfo.icon} />
                <Link
                  variant="quiet"
                  typographyVariant="bodySecondary"
                  className="m-l-1s"
                  href={prependUrlProtocolIfNone(`${externalLinkInfo.prefix}${websites[link]}`) || undefined}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {websites[link]}
                </Link>
              </li>
            );
          }
          return null;
        })}
      </ul>
    </div>
  );
};

export default withFragments({
  websites: gql`
    fragment ExternalLinksFragment on InstructorsV1_org_coursera_catalogp_InstructorWebsites {
      website
      websiteFacebook
      websiteTwitter
      websiteLinkedin
    }
  `,
})(ExternalLinks);
